import styled, { keyframes } from "styled-components";

const slideIn = keyframes`
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
`;

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.75);
  backdrop-filter: blur(5px);
  z-index: 1100;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
`;

export const Container = styled.div`
  background: #fff;
  width: 100%;
  max-width: 550px;
  border-radius: 20px;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.5);
  overflow: hidden;
  animation: ${slideIn} 0.3s ease-out;
  display: flex;
  flex-direction: column;
`;

export const Header = styled.div`
  background: #111827;
  padding: 20px 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  h2 {
    color: #d4af37;
    margin: 0;
    font-size: 18px;
    font-weight: 700;
    display: flex;
    align-items: center;
    gap: 10px;
  }

  button {
    background: transparent;
    border: none;
    color: white;
    font-size: 20px;
    cursor: pointer;
    transition: color 0.2s;
    &:hover {
      color: #d4af37;
    }
  }
`;

export const Body = styled.div`
  padding: 30px;
  max-height: 70vh;
  overflow-y: auto;
`;

/* ESTADOS DE VAZIO / SEM SAQUE */
export const EmptyState = styled.div`
  text-align: center;
  padding: 20px 0;
  color: #4b5563;

  svg {
    font-size: 50px;
    color: #9ca3af;
    margin-bottom: 20px;
  }

  h3 {
    margin: 0 0 10px 0;
    color: #111827;
  }

  p {
    font-size: 14px;
    line-height: 1.5;
  }
`;

/* LISTA DE CAIXINHAS */
export const BoxGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 15px;
`;

export const BoxCard = styled.div`
  background: #f9fafb;
  border: 2px solid #e5e7eb;
  border-radius: 12px;
  padding: 15px;
  cursor: pointer;
  transition: all 0.2s;
  position: relative;

  &:hover {
    border-color: #d4af37;
    background: #fffbf0;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(212, 175, 55, 0.15);
  }

  .header-card {
    font-size: 12px;
    color: #6b7280;
    margin-bottom: 5px;
    font-weight: 600;
  }

  .value {
    font-size: 18px;
    font-weight: 800;
    color: #10b981;
    margin-bottom: 5px;
  }

  .type {
    font-size: 11px;
    color: #d4af37;
    font-weight: 700;
    text-transform: uppercase;
  }
`;

/* FORMULÁRIO DE SAQUE */
export const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  box-sizing: border-box;
`;

export const SelectedBoxInfo = styled.div`
  background: #f0fdf4;
  border: 1px solid #bbf7d0;
  padding: 15px;
  border-radius: 10px;
  text-align: center;
  box-sizing: border-box;

  p {
    margin: 0;
    font-size: 13px;
    color: #166534;
    box-sizing: border-box;
  }

  h3 {
    margin: 5px 0 0 0;
    color: #15803d;
    font-size: 24px;
  }
`;

export const InputGroup = styled.div`
  label {
    display: block;
    font-size: 14px;
    font-weight: 600;
    color: #374151;
    margin-bottom: 8px;
  }

  .currency-input {
    width: 100%;
    padding: 15px;
    font-size: 20px;
    border: 2px solid #e5e7eb;
    border-radius: 10px;
    outline: none;
    font-weight: 700;
    color: #111827;
    transition: border-color 0.2s;
    box-sizing: border-box;

    &:focus {
      border-color: #d4af37;
    }
  }

  .error-msg {
    color: #ef4444;
    font-size: 12px;
    margin-top: 5px;
    display: block;
  }
`;

export const PercentageButtons = styled.div`
  display: flex;
  gap: 10px;
  margin-bottom: 10px;

  button {
    flex: 1;
    padding: 8px;
    background: #f3f4f6;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    font-size: 12px;
    font-weight: 600;
    color: #4b5563;
    cursor: pointer;
    transition: all 0.2s;

    &:hover {
      background: #e5e7eb;
      color: #111827;
    }
  }
`;

export const Footer = styled.div`
  padding: 20px 30px;
  background: #f9fafb;
  border-top: 1px solid #e5e7eb;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
`;

export const Button = styled.button`
  padding: 12px 24px;
  border-radius: 10px;
  font-weight: 700;
  font-size: 14px;
  cursor: pointer;
  border: none;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: all 0.2s;

  &.cancel {
    background: transparent;
    color: #6b7280;
    &:hover {
      background: #e5e7eb;
    }
  }

  &.confirm {
    background: linear-gradient(135deg, #d4af37, #b88a00);
    color: white;
    box-shadow: 0 4px 10px rgba(212, 175, 55, 0.3);

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 6px 15px rgba(212, 175, 55, 0.4);
    }

    &:disabled {
      background: #d1d5db;
      color: #9ca3af;
      cursor: not-allowed;
      transform: none;
      box-shadow: none;
    }
  }
`;
